export const MAX_NICKNAME_LENGTH = 15;
export const MAX_TEXT_MESSAGE_LENGTH = 200;
